import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ComingSoon from 'src/routes/ComingSoon';
import ThinkApp from './routes/ThinkApp';
import PrivacyPolicy from './routes/PrivacyPolicy';
import TreeSurface from './routes/Surfaces/Tree/TreeSurface';
import Login from './routes/Login';
import Logout from './routes/Logout';
import DevLogin from './routes/DevLogin';
import AutoLogin from './routes/AutoLogin';
import RequireAuth, { RequireStaff } from './components/RequireAuth';
import FocusSurface from './routes/Surfaces/Focus/FocusSurface';
import GraphSurface from './routes/Surfaces/GraphSurface';
import FlowD3ForceSurface from './routes/Surfaces/Flow/FlowD3ForceSurface';
import FlowDagreSurface from './routes/Surfaces/Flow/FlowDagreSurface';
import SourceGridSurface from './routes/Surfaces/SourceGrid';
import ReadWriteSurface from './routes/Surfaces/ReadWrite/ReadWriteSurface';
import DevRoute from './routes/dev/document_sections';
// import RagDevRoute from './routes/dev/ragRequest'; // Removed - replaced by new AI backend
import BatchProcessDocuments from './routes/staff/batch_process_documents';
import ExternalRedirect from './components/ExternalRedirect';

const App: React.FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
        <Routes>
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/soon" element={<ComingSoon />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          {/* Enable dev routes in development mode or devcloud mode (for CI/E2E tests) */}
          {(process.env.NODE_ENV === 'development' || import.meta.env.DEV) && (
            <>
              <Route path="/login/dev" element={<DevLogin />} />
              <Route path="/login/auto" element={<AutoLogin />} />
            </>
          )}
          <Route
            path="/extension"
            element={
              <ExternalRedirect to="https://chromewebstore.google.com/detail/annote/becaeodideblenfemdnhjgbipehcphia" />
            }
          />
          {/* <Route path="/login/annon" element={<CreateUserLogin />} /> */}

          {/* Authed Routes */}
          <Route
            path="/focus"
            element={
              <RequireAuth>
                <ThinkApp surface={<FocusSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/graph"
            element={
              <RequireAuth>
                <ThinkApp surface={<GraphSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/flowd3force"
            element={
              <RequireAuth>
                <ThinkApp surface={<FlowD3ForceSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/flow"
            element={
              <RequireAuth>
                <ThinkApp surface={<FlowDagreSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/sourcegrid"
            element={
              <RequireAuth>
                <ThinkApp surface={<SourceGridSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/tree"
            element={
              <RequireAuth>
                <ThinkApp surface={<TreeSurface />} />
              </RequireAuth>
            }
          />
          <Route
            path="/readwrite"
            element={
              <RequireAuth>
                <ThinkApp surface={<ReadWriteSurface />} />
              </RequireAuth>
            }
          />

          {/* Admin/Staff Routes */}
          <Route
            path="/staff/batch-process-documents"
            element={
              <RequireStaff>
                <BatchProcessDocuments />
              </RequireStaff>
            }
          />
          {process.env.NODE_ENV === 'development' && (
            <>
              <Route
                path="/dev"
                element={
                  <RequireAuth>
                    <DevRoute />
                  </RequireAuth>
                }
              />
              {/* Removed - replaced by new AI backend
              <Route
                path="/dev/ragRequest"
                element={
                  <RequireAuth>
                    <RagDevRoute />
                  </RequireAuth>
                }
              />
              */}
            </>
          )}

          <Route path="/" element={<ComingSoon />} />
          <Route path="*" element={<div>Route not found</div>} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default App;
